// import React from 'react'
// import "./advertisingBanner.css"
// import { FaWhatsapp, FaInstagram, FaYoutube, FaFacebookF } from "react-icons/fa";
// import { FaXTwitter, FaTiktok } from "react-icons/fa6";



// const AdvertisingBanner = ({ heading, isRtl }) => {
//     return (
//         <>
//             <section className="advertisingBannerNew">
//                 <div className="container-fluid containerSpacing">
//                     <div className="row align-items-center">
//                         <div className="col-lg-6 col-md-6 col-12">
//                             <h2 className="heading">{heading}</h2>
//                         </div>
//                         <div className="col-lg-6 col-md-6 col-12">
//                             <div className="social-box">
//                                 <ul>
//                                     <li>
//                                         <a href="">
//                                             <FaWhatsapp />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a href="">
//                                             <FaInstagram />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a href="">
//                                             <FaXTwitter />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a href="">
//                                             <FaYoutube />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a href="">
//                                             <FaTiktok />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a href="">
//                                             <FaFacebookF />
//                                         </a>
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     )
// }

// export default AdvertisingBanner



import React, { useState, useEffect } from "react";
import "./advertisingBanner.css";
import { FaWhatsapp, FaInstagram, FaYoutube, FaFacebookF } from "react-icons/fa";
import { FaXTwitter, FaTiktok } from "react-icons/fa6";

const AdvertisingBanner = ({ texts = [], isRtl }) => {
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        // if (!texts.length) return; // Prevent animation when the array is empty

        const interval = setInterval(() => {
            setIsAnimating(true); // Start the slide-out animation
            setTimeout(() => {
                setCurrentTextIndex((prev) => (prev + 1) % texts.length); // Update text index
                setIsAnimating(false); // Start the slide-in animation
            }, 1000); // Match slide-out animation duration
        }, 6000); // 5s display time + 1s animation

        return () => clearInterval(interval);
    }, [texts.length]);

    if (!texts.length) {
        return <h2 className="heading">No text to display</h2>; // Fallback UI
    }

    return (
        <section className="advertisingBannerNew">
            <div className="container-fluid containerSpacing">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 col-12">
                        <h2
                            className={`heading ${isAnimating ? "slide-out" : "slide-in"
                                }`}
                            dir={isRtl ? "rtl" : "ltr"}
                            key={currentTextIndex}
                        >
                            {texts[currentTextIndex]}
                        </h2>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="social-box">
                            <ul>
                                <li>
                                    <a href="">
                                        <FaWhatsapp />
                                    </a>
                                </li>
                                <li>
                                    <a href="">
                                        <FaInstagram />
                                    </a>
                                </li>
                                <li>
                                    <a href="">
                                        <FaXTwitter />
                                    </a>
                                </li>
                                <li>
                                    <a href="">
                                        <FaYoutube />
                                    </a>
                                </li>
                                <li>
                                    <a href="">
                                        <FaTiktok />
                                    </a>
                                </li>
                                <li>
                                    <a href="">
                                        <FaFacebookF />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AdvertisingBanner;
